export default "__VITE_ASSET__af579db6__"